import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import './styles/GlobalStyles.css';
import './styles/App.css';

import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/Home';
import About from './pages/About';
import GruppPsy from './pages/GruppPsy';

import FindPsychologist from './pages/FindPsychologist';
import Archive from './pages/Archive';
import Colleagues from './pages/Colleagues';
import JoinAssociation from './pages/JoinAssociation';
import Education from './pages/Education';

const basename = process.env.NODE_ENV === 'production' ? '/' : '/';

function App() {
  return (
    <Router basename={basename}>
      <div className="App">
        <ScrollToTop />
        <Header />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />

          {/* Старые адреса не ломаем: они ведут в нужный раздел новой страницы */}
          <Route path="/codex" element={<Navigate to="/about#ethics" replace />} />
          <Route path="/friends" element={<Navigate to="/about#friends" replace />} />

          <Route path="/resources" element={<Colleagues />} />
    <Route path="/benefits/grupp_psy" element={<GruppPsy />} />
          <Route path="/find-psychologist" element={<FindPsychologist />} />
          <Route path="/archive" element={<Archive />} />
          <Route path="/benefits/education" element={<Education />} />
          <Route path="/join_association" element={<JoinAssociation />} />

        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
